import { render, staticRenderFns } from "./PneumoniaIndexAndPrevalenceComponent.vue?vue&type=template&id=0aaabef4&scoped=true&"
import script from "./PneumoniaIndexAndPrevalenceComponent.vue?vue&type=script&lang=ts&"
export * from "./PneumoniaIndexAndPrevalenceComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PneumoniaIndexAndPrevalenceComponent.vue?vue&type=style&index=0&id=0aaabef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaabef4",
  null
  
)

export default component.exports